module.exports = __webpack_public_path__ + "static/media/js.54087505.png";